<template>
  <div>
    <profilesPage
      :loading="loading"
      :path="path"
      :title="title"
      :create-btn="createBtn"
      :select="select"
      :select-options="selectOptions"
      :fields="fields"
      :items="items"
      :name="name"
      :pageTotal="pageTotal"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
      @handleSearch="handleSearch"
      :currentPage="currentPage"
      :rows="rows"
      :sort="sort"
      :direct="direct"
      @orderHead="orderHead"
      @selectFilmType="selectFilmType"
    />
  </div>
</template>

<script>
import profilesPage from '../profilespage/profilesPage'
import { getProducerApi } from '@/api/film-material-management/producer'

export default {
  components: {
    profilesPage,
  },
  data() {
    return {
      sort: 'id',
      direct: 'desc',
      loading: false,
      title: '監製',
      name: 'producer',
      createBtn: '開立新監製記錄',
      select: '全部地區',
      path: '/dashboard/producer-info',
      selectOptions: ['全部地區', '香港', '非香港'],
      currentPage: 1,
      fields: [
        {
          key: 'id',
          label: 'Producer ID',
          sortKey: 'id',
        },
        {
          key: 'name_en',
          label: 'Producer Name',
          sortKey: 'producer_name_en',
        },
        {
          key: 'name_cn',
          label: '監製名稱',
          sortKey: 'producer_name_zh_hk',
        },
        {
          key: 'action',
          label: '',
        },
      ],
      items: [],
      pageTotal: 10,
      rows: 20,
      search: '',
      location: '',
      isOld: 0,
    }
  },
  methods: {
    selectFilmType(val) {
      this.isOld = val
      this.getProducerList()
    },
    orderHead(key, direct) {
      this.sort = key
      this.direct = direct
      this.getProducerList()
    },
    handleSizeChange(val) {
      this.rows = val
      this.getProducerList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getProducerList()
    },
    handleSearch(val) {
      this.currentPage = 1
      this.rows = val.rows
      this.location = val.selectArea
      this.search = val.search
      this.sort = val.sort
      this.direct = val.direct
      this.getProducerList()
    },
    getProducerList() {
      this.loading = true
      const data = {
        page: this.currentPage,
        count: this.rows,
        area: this.location,
        search: this.search,
        sort: this.sort,
        direct: this.direct,
        arch: this.isOld,
      }
      getProducerApi(data)
        .then((res) => {
          this.items = res.data
          this.pageTotal = res.total
          const arr = []
          this.items.forEach((el) => {
            const obj = new Object()
            obj.id = el.id
            obj.name_cn = el.producer_name_zh_hk
            obj.name_en = el.producer_name_en
            obj.name_other = el.producer_name_other
            obj.area = el.area
            arr.push(obj)
          })
          this.items = arr
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.getProducerList()
  },
}
</script>

<style lang="scss" scoped>
</style>
